import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARD from '../apiUrls';

const mutationSuspendSimCard = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuids }) => {
            return client.post(SIM_CARD.SUSPEND.url, { uuids });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationSuspendSimCard;